<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widget-two-columns-one-gap-fifty-percent" *ngIf="widgetData">
    <div class="fullWidth">
        <div class="table-part">
            <table class="widget-flex" style="height: 100%;" aria-hidden="true">
                <thead>
                    <tr class="widget-ruller-flex">
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="6"><widget-label [widget]="this" [fieldName]="'localCourt'" [align]="'left'" [bold]="true"></widget-label></td>
                        <td colspan="10" *ngIf="editMode">
                          <input class="widget-input-text widget-h1 widget-align-right" maxlength="255" [(ngModel)]="widgetData.localCourt" (ngModelChange)="setDirtyFlag(true)" />
                        </td>
                        <td colspan="10" class="widget-h1 widget-align-right" *ngIf="!editMode">{{ widgetData.localCourt }}</td>
                    </tr>
                    <tr>
                      <td colspan="6"><widget-label [widget]="this" [fieldName]="'excerptDate'" [align]="'left'" [bold]="true"></widget-label></td>
                      <td colspan="10" *ngIf="editMode">
                        <input class="widget-input-text widget-h1 widget-align-right" maxlength="255" [(ngModel)]="widgetData.excerptDate" (ngModelChange)="setDirtyFlag(true)" />
                      </td>
                      <td colspan="10" class="widget-h1 widget-align-right" *ngIf="!editMode">{{ widgetData.excerptDate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="space-part">&nbsp;</div>
        <div class="table-part">
            <table class="widget-flex" style="height: 100%;" aria-hidden="true">
                <thead>
                    <tr class="widget-ruller-flex">
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                        <th scope="col" class="widget-grid-column">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                      <td colspan="6"><widget-label [widget]="this" [fieldName]="'landRegister'" [align]="'left'" [bold]="true"></widget-label></td>
                        <td colspan="10" *ngIf="editMode">
                          <input class="widget-input-text widget-h1 widget-align-right" maxlength="255" [(ngModel)]="widgetData.landRegister" (ngModelChange)="setDirtyFlag(true)" />
                        </td>
                        <td colspan="10" class="widget-h1 widget-align-right" *ngIf="!editMode">{{ widgetData.landRegister }}</td>
                    </tr>
                    <tr>
                        <td colspan="16" class="space">&nbsp;</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="parts-separator"></div>

        <table data-id="widgetTenure" id="widgetTenure" class="widget-large widgetTenureClass" aria-hidden="true">
          <thead>
            <tr class="widget-ruller-large">
              <th scope="col" class="widget-grid-column add-delete-column" *ngIf="editMode">&nbsp;</th>
              <th scope="col" class="widget-grid-column add-delete-column" *ngIf="editMode">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-space">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
            </tr>
          </thead>
          <tr>
            <th scope="col" colspan="1" *ngIf="editMode"><span class="k-icon k-i-minus" (click)="tenureOwnerDeleteClicked()"></span></th>
            <th scope="col" colspan="1" *ngIf="editMode"><span class="k-icon k-i-plus" (click)="tenureOwnerAddClicked()"></span></th>
            <th scope="col" colspan="9" class="widget-align-left">{{'tenure.owner' | rdTranslate}}</th>
            <th scope="col" colspan="3" class="widget-align-center">{{'tenure.sheet' | rdTranslate}}</th>
            <th scope="col" colspan="3" class="widget-align-center">{{'tenure.plot' | rdTranslate}}</th>
            <th scope="col" colspan="3" class="widget-align-center">{{'tenure.parcel' | rdTranslate}}</th>
            <th scope="col" colspan="17" class="widget-align-left-no-padding" *ngIf="!editMode">{{'tenure.section2Restrictions' | rdTranslate}}</th>
            <th scope="col" colspan="15" class="widget-align-left-no-padding" *ngIf="editMode">{{'tenure.section2Restrictions' | rdTranslate}}</th>
          </tr>

          <tbody *ngFor="let supportTenure of widgetData.supportTenure">
            <tr class="TenureOwnerRow">
              <td colspan="1" *ngIf="editMode" style="text-align: center;vertical-align: top">
                <input type="checkbox" [(ngModel)]="supportTenure.checked" />
              </td>
              <td colspan="1" *ngIf="editMode">&nbsp;</td>
              <td colspan="9" class="widget-h1 owner-edit-td" *ngIf="editMode" style="vertical-align: top">
                <input class="widget-input-text widget-h1" maxlength="255" [(ngModel)]="supportTenure.owner" (ngModelChange)="setDirtyFlag(true)" />
              </td>
              <td colspan="9" class="widget-h1 widget-align-left owner-description-td" *ngIf="!editMode">
                <span>{{ supportTenure.owner }}</span>
              </td>
              <td colspan="26">
                <table class="TenureOwnerData widget-ruller cellspacing-0 cellpadding-0" style="width:100%; margin:0"  aria-hidden="true">
                  <tbody *ngIf="editMode">
                    <tr *ngFor="let entry of supportTenure.supportTenureData">
                      <td colspan="3" class="widget-h1" style="border: none"><input class="widget-input-text widget-h1" style="text-align:right" maxlength="255" [(ngModel)]="entry.sheet" (ngModelChange)="setDirtyFlag(true)" /></td>
                      <td colspan="3" class="widget-h1" style="border: none"><input class="widget-input-text widget-h1" style="text-align:right" maxlength="255" [(ngModel)]="entry.plot" (ngModelChange)="setDirtyFlag(true)" /></td>
                      <td colspan="3" class="widget-h1" style="border: none"><input class="widget-input-text widget-h1" style="text-align:right" maxlength="255" [(ngModel)]="entry.parcel" (ngModelChange)="setDirtyFlag(true)" /></td>
                      <td colspan="16" class="widget-h1 section2-edit" style="border: none">
                        <pollux-report-designer-resizing-text-field ngDefaultControl class="widget-input-text widget-h1" style="text-align:right" [(ngModel)]="entry.section2" (ngModelChange)="setDirtyFlag(true);"></pollux-report-designer-resizing-text-field>
                      </td>
                      <td colspan="1" style="text-align: left; border: none; padding-left: 2px;">
                        <input type="checkbox" [(ngModel)]="entry.checked" />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="26" style="width: 100%; font-size:6px; margin: 0">
                        <span class="k-icon k-i-plus" (click)="tenureOwnerDataAddClicked(supportTenure)"></span>
                        <span class="k-icon k-i-minus" (click)="tenureOwnerDataDeleteClicked(supportTenure)"></span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="!editMode">
                    <tr *ngFor="let entry of supportTenure.supportTenureData">
                      <td *ngIf="!isRowEmpty(1, entry)" class="widget-h1 first-3">{{ entry.sheet }}</td>
                      <td *ngIf="!isRowEmpty(1, entry)" class="widget-h1 first-3">{{ entry.plot }}</td>
                      <td *ngIf="!isRowEmpty(1, entry)" class="widget-h1 first-3">{{ entry.parcel }}</td>
                      <td *ngIf="!isRowEmpty(1, entry)" class="widget-h1 widget-align-left section2" colspan="16">{{ entry.section2 }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>

          <tr><td class="space">&nbsp;</td></tr>
        </table>
    </div>

</div>
